import React, { useEffect, useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useAppContext } from "../../../shared/functions/Context";
import RequestTable from "./RequestsTable";
import { ITemplateRating } from "../../../shared/models/three-sixty-feedback-models/TemplateRating";

const NewRequests = observer(() => {
  const { api, store } = useAppContext();
  const [data, setData] = useState<ITemplateRating[]>([]);
    const me = store.auth.meJson?.uid
    const [description, setDescription] = useState("")
     const [loading, setLoading] = useState(true)


  const fetchData = useCallback(async () => {
    try {
      await api.templateRating.getAll();
      const allRatings = store.templateRating.all.map((rating) => rating.asJson);
      console.log("all my ratings",allRatings);
      
      const newRequests = allRatings.filter((rating) => !rating.archived);
      setData(newRequests);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [api.templateRating, store.templateRating]);

  useEffect(() => {
    const load = async () => {
      try {
        // 1. Load rating assignments
        await api.ratingAssignments.getAll()
        const activeRating = store.ratingAssignments.all.find((rating) => rating.asJson.isActive === true)?.asJson

        if (activeRating) {
          setDescription(activeRating.description ?? "")
        }

        // 2. Ensure we have both 'me' and 'description'
        if (me && activeRating?.description) {
          console.log("calling api")

          await Promise.all([
            api.valueRating.getAll(me, activeRating.description),
            api.leadershipRating.getAll(me, activeRating.description),
            api.templateRating.getAllWithDescription(activeRating.description),
          ])
        } else {
          console.warn("No valid 'me' or active rating description found.")
        }
      } catch (error) {
        console.error("Error occurred while loading data:", error)
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [api, me]) // Remove store.ratingAssignments.all from dependencies

 

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDataChange = useCallback(() => {
    fetchData();
  }, []);

  return (
    <div>
      <RequestTable data={data} onDataChange={handleDataChange} />
    </div>
  );
});

export default NewRequests;
